import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { get } from 'lodash';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import ToggleField from '../app-main/components/reduxForms/fields/ToggleField/ToggleField';
import TextAreaField from 'shared-components/reduxForms/fields/TextAreaField/TextAreaField';
import validateElectricalForm from './forms/validateElectricalForm';
import onSubmitProductionForms from './forms/onSubmitProductionForms';
import { mapBoolToString } from './data/utils';
import ButtonNavigation from '../app-faq-components/ButtonNavigation';
import { FormattedMessage, injectIntl, intlShape, defineMessages } from 'react-intl';

const ElectricalForm = ({
  error,
  handleSubmit,
  intl,
  ...props
}) => {
  const translationMessages = defineMessages({
    yes: {
      id: 'hosting.electrical_form.yes',
      defaultMessage: 'Yes'
    },
    no: {
      id: 'hosting.electrical_form.no',
      defaultMessage: 'No'
    }
  });
  return (
    <form className="flex-basis-100" onSubmit={handleSubmit}>
      <h2><FormattedMessage id="hosting.electrical_form.form_heading" defaultMessage="Electrical" /></h2>
      <p className="text-gray-600"><FormattedMessage id="hosting.electrical_form.electric_text" defaultMessage="Shoots often involve power-intense equipment and need easy access to electrical outlets. If you don’t know, just skip these." /></p>
      <div className="questions-section">
        <h6><FormattedMessage id="hosting.electrical_form.circuit_breaker_access_heading" defaultMessage="Can guests access the circuit breaker?" /></h6>
        <p className="text-gray-600"><FormattedMessage id="hosting.electrical_form.circuit_breaker_access_text" defaultMessage="Production crews may need to reset flipped breakers etc" /></p>
        <Field
          name='can_access_circuit_breaker'
          component={ToggleField}
          attributes={{
            'data-testing-id': 'can_access_circuit_breaker'
          }}
          firstOption={
            {
              id: 'can_access_circuit_breaker_true',
              value: 'true',
              label: intl.formatMessage(translationMessages.yes)
            }}
          secondOption={
            {
              id: 'can_access_circuit_breaker_false',
              value: 'false',
              label: intl.formatMessage(translationMessages.no)
            }}
        />
      </div>
      <div className="questions-section">
        <h6><FormattedMessage id="hosting.electrical_form.electrical_system_description_heading" defaultMessage="Describe the electrical system of your space" /></h6>
        <ul className="list-style-inside no-gutter text-gray-600 margin-lg-bottom">
          <li><FormattedMessage id="hosting.electrical_form.power_rating" defaultMessage="What is the power rating of the space?" /></li>
          <li><FormattedMessage id="hosting.electrical_form.number_of_outlets" defaultMessage="How many outlets? Where are they?" /></li>
          <li><FormattedMessage id="hosting.electrical_form.circuit_breaker_location" defaultMessage="Where is the circuit breaker?" /></li>
        </ul>
        <Field
          name='electrical_system_description'
          component={TextAreaField}
          attributes={{
            'data-testing-id': 'electrical_system_description'
          }}
          maxLength={1000}
        />
      </div>
      <hr className="space-type-line-break"/>
      <div className="text-danger text-small margin-xl-bottom">{error}</div>
      <ButtonNavigation {...props} />
    </form>
  );
};

ElectricalForm.propTypes = {
  handleSubmit: PropTypes.func,
  error: PropTypes.string,
  insuranceToggle: PropTypes.bool,
  moveFurnitureToggle: PropTypes.bool,
  spaceId: PropTypes.string,
  intl: intlShape
};

const config = {
  form: 'PRODUCTION_ELECTRICAL_FORM',
  onSubmit: onSubmitProductionForms,
  validate: validateElectricalForm
};

function mapStateToProps (state) {
  const productionDetails = get(state, 'space.data.production_details', {});

  return {
    initialValues: {
      ...mapBoolToString(productionDetails)
    }
  };
}

export default connect(mapStateToProps)(reduxForm(config)(injectIntl(ElectricalForm)));
